import { Checkbox, Field } from 'Components/Core';
import { SectionGroup } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import AsMeasuredConstantDryMassWorksheet from './MeasuredDryMass/MeasuredMoistureContentWorksheet';
import AsOversizeCorrectionSampleMassSection from './OversizeCorrection/OversizeCorrectionSampleMassSection';
import AsOversizePropertySection from './OversizePropertySection';

let AsOversizeCorrectionDataSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, prefixName }) => {
  const noOversizeMaterial = useSelector(
    pipe(createWorksheetSelector!('OversizeCorrectionData.NoOversizeMaterial'), valueOrDefault(false))
  ) as boolean;
  return (
    <>
      <SectionGroup>
        <Field input={<Checkbox />} name="OversizeCorrectionData.NoOversizeMaterial" />
        {!noOversizeMaterial && (
          <>
            <AsOversizeCorrectionSampleMassSection />
            <AsMeasuredConstantDryMassWorksheet />
            <AsOversizePropertySection />
          </>
        )}
      </SectionGroup>
    </>
  );
};

AsOversizeCorrectionDataSection = withInjectedProps(AsOversizeCorrectionDataSection);

export { AsOversizeCorrectionDataSection };
export default AsOversizeCorrectionDataSection;
